import { IconButton, Tooltip } from "@mui/material";

import BadgeEstados from "../../../../components/BadgeEstado";
import { EyeIcon } from "../../../../components/Icons";
import HeaderColumn from "../../../Actas/components/HeaderColumn";
import { format, parse } from "date-fns";

export const tableData = (
  data,
  setFiltersField,
  setOrder,
  setOrderField,
  coleccionActasDetalle,
  setAllActaDetalle,
  handlerModal,
  getActaDetalle,
  filterEstado
) => {
  console.log(filterEstado);

  const headerFecha =
    {
      "no-notificadas": "Fecha No Notificada",
      notificadas: "Fecha Notificacion",
      reparto: "Fecha Asignacion",
    }[filterEstado] || "Fecha Reporte";
  const columns = [
    // { field: "id", headerName: "ID", hide: true },
    {
      field: "numero_acta",
      headerName: "Acta",
      // minWidth: 110,
      width: "130",
      //
      sortable: true,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "estado_id",
      headerName: "Estado",
      width: "150",

      sortable: true,
      renderCell: (params) => {
        return <BadgeEstados estado_id={params.row.estado_id} />;
      },
    },
    {
      field: "localidad",
      headerName: "Localidad",
      minWidth: 170,

      sortable: true,
    },

    {
      // in:reparto,notificadas,no-notificadas
      field: "fecha_reporte",
      headerName: headerFecha,
      // minWidth: 100,
      //
      width: "200",
      sortable: true,
      renderCell: (params) => {
        const fechaFormateada = format(
          parse(params?.row?.fecha_reporte, "dd/MM/yyyy HH:mm:ss", new Date()),
          "dd/MM/yy HH:mm"
        );
        if (!params.row.fecha_reporte) {
          return <BadgeEstados estado_id={params.row.estado_id} />;
        } else {
          // return <span>{params.row.fecha_reporte}</span>;
          return <span>{fechaFormateada}</span>;
        }
      },
    },
    ...(filterEstado == "abonadas"
      ? [
          {
            field: "monto",
            headerName: "Monto",
            minWidth: 160,
            // flex: 2,
            sortable: false,
            // renderHeader: () => {
            //   return (
            //     <HeaderColumn
            //       label={"Motivo"}
            //       color={[8, 9, 10].includes(estado_id) ? "#111" : "#FFF"}
            //       setFiltersField={setFiltersField}
            //       setOrder={setOrder}
            //       setOrderField={setOrderField}
            //       typeInput={"select"}
            //       field={"motivo"}
            //       place={"Motivo"}
            //     />
            //   );
            // },
            renderCell: (params) => {
              return <>$ {params?.row.monto}</>;
            },
          },
        ]
      : []),

    // {
    //   // field: "estado_id",
    //   headerName: "Monto",
    //   // minWidth: 300,
    //   width: "150",
    //   // flex: 2,
    //   sortable: true,
    //   renderCell: (params) => {
    //     // return <BadgeEstados estado_id={params.row.estado_id} />;
    //     return "Plata";
    //   },
    // },
  ];

  const rows =
    data?.map((d, index) => {
      return {
        id: d?.id,
        fecha_hora: d?.fecha_hora,
        numero_acta: d?.numero_acta,
        localidad: d?.localidad,
        fecha_reporte: d?.fecha_reporte,
        notificador_nombre: d?.nombre_notificador || null,
        estado_id: d?.estado_id || null,
        fecha_notificacion: d?.fecha_notificacion || null,
        motivo: d?.motivo || null,
        monto: d?.ultimo_recibo_monto?.monto || null,
      };
    }) || [];

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.plate)?.toString().toLowerCase().includes(value) ||
      String(d.fecha_hora)?.toString().toLowerCase().includes(value) ||
      String(d.infraccion)?.toString().toLowerCase().includes(value) ||
      String(d.documento)?.toString().toLowerCase().includes(value) ||
      String(d.localidad)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
